<div class="operaciones-container">

  <!-- ── Sub-tabs ─────────────────────────────────────────────────────── -->
  <div class="sub-tabs-bar">
      <nav class="tabs sub-tabs" aria-label="Vistas de operaciones societarias">
      <ul>
        @if (displayedOperaciones().length > 0) {
          <li [class.is-active]="activeSubTab() === 'estadoActual'">
            <a (click)="setSubTab('estadoActual')" [attr.aria-selected]="activeSubTab() === 'estadoActual'" role="tab">
              Estado actual
            </a>
          </li>
        }
        <li [class.is-active]="activeSubTab() === 'operaciones'">
          <a (click)="setSubTab('operaciones')" [attr.aria-selected]="activeSubTab() === 'operaciones'" role="tab">
            Operaciones ({{ displayedOperaciones().length }})
          </a>
        </li>
      </ul>
    </nav>

    <!-- Nueva operación button: hidden in snapshot mode -->
    @if (!isSnapshotMode()) {
      <button type="button" class="button is-outlined nueva-operacion-btn" (click)="openNewModal()">
        <fa-icon [icon]="faPlus" aria-hidden="true"></fa-icon>
        Nueva operación societaria
      </button>
    }
  </div>

  <!-- ── Estado actual ─────────────────────────────────────────────────── -->
  @if (activeSubTab() === 'estadoActual' && displayedOperaciones().length > 0) {
    <div class="estado-actual-panel" role="tabpanel" aria-label="Estado actual del formulario">
      @if (isLoadingEstadoActual() || isLoading()) {
        <div class="operaciones-loading" aria-live="polite">Cargando estado actual...</div>
      } @else if (isSnapshotMode()) {
        @if (!estadoActualSnapshot()) {
          <div class="operaciones-empty">
            <p>No hay datos de constitución para las operaciones anteriores a esta fecha.</p>
          </div>
        } @else {
          <app-constitution-readonly [data]="estadoActualSnapshot()" [sections]="['objetoSocial','capitalSocial','socios','administracion','apoderados']"></app-constitution-readonly>
        }
      } @else if (!estadoActual()) {
        <div class="operaciones-empty">
          <p>No hay datos de constitución registrados para este cliente.</p>
        </div>
      } @else {
        <app-constitution-readonly [data]="estadoActual()" [sections]="['objetoSocial','capitalSocial','socios','administracion','apoderados']"></app-constitution-readonly>
      }
    </div>
  }

  <!-- ── Operaciones accordion ─────────────────────────────────────────── -->
  @if (activeSubTab() === 'operaciones') {
    <div role="tabpanel" aria-label="Historial de operaciones societarias">

      @if (isLoading()) {
        <div class="operaciones-loading" aria-live="polite">Cargando operaciones...</div>
      } @else if (displayedOperaciones().length === 0) {
        <div class="operaciones-empty">
          @if (isSnapshotMode()) {
            <p>No hay operaciones societarias anteriores a la fecha seleccionada.</p>
          } @else {
            <p>No hay operaciones societarias registradas para este cliente.</p>
          }
        </div>
      } @else {

      <ol class="operaciones-list" aria-label="Operaciones societarias">
        @for (op of displayedOperaciones(); track op.id; let i = $index) {
          <li class="operacion-item" [class.is-expanded]="isExpanded(op.id)">

            <!-- Accordion header -->
            <button
              type="button"
              class="operacion-header"
              (click)="toggle(op.id)"
              [attr.aria-expanded]="isExpanded(op.id)"
              [attr.aria-controls]="'op-body-' + op.id"
            >
              <span class="operacion-header-left">
                <span class="operacion-num">{{ i + 1 }}.</span>
                <span class="operacion-labels">
                  <span class="op-categoria-badge">{{ op.categoriaLabel }}</span>
                  @if (op.subtipoLabel) {
                    <span class="op-subtipo-label">{{ op.subtipoLabel }}</span>
                  }
                </span>
              </span>
              <span class="operacion-header-right">
                @if (!isExpanded(op.id) && op.fechaEscritura) {
                  <span class="operacion-summary">
                    Escritura {{ op.fechaEscritura }}
                    @if (op.notario) { · Notario {{ op.notario }} }
                    @if (op.protocolo) { · Protocolo {{ op.protocolo }} }
                  </span>
                }
                @if (op.id === lastCreatedOpId() && !isSnapshotMode()) {
                  <span class="op-actions" role="group" [attr.aria-label]="'Acciones de operación ' + (i + 1)">
                    <button
                      type="button"
                      class="op-action-btn op-action-edit"
                      (click)="editOperacion($event, op)"
                      aria-label="Editar operación"
                      title="Editar"
                    >
                      <fa-icon [icon]="faPencil" aria-hidden="true"></fa-icon>
                    </button>
                    <button
                      type="button"
                      class="op-action-btn op-action-delete"
                      (click)="openDeleteModal($event, op)"
                      aria-label="Eliminar operación"
                      title="Eliminar"
                    >
                      <fa-icon [icon]="faTrash" aria-hidden="true"></fa-icon>
                    </button>
                  </span>
                }
                <fa-icon
                  [icon]="isExpanded(op.id) ? faChevronUp : faChevronDown"
                  class="chevron-icon"
                  aria-hidden="true"
                ></fa-icon>
              </span>
            </button>

            <!-- Accordion body -->
            @if (isExpanded(op.id)) {
              <div class="operacion-body" [id]="'op-body-' + op.id" role="region">

                <!-- Operation metadata card -->
                <div class="op-meta-card">
                  <div class="op-fields-grid">
                    <div class="op-field">
                      <label class="op-label">Fecha de escritura</label>
                      <div class="op-value">{{ op.fechaEscritura || '—' }}</div>
                    </div>
                    <div class="op-field">
                      <label class="op-label">Concepto de escritura</label>
                      <div class="op-value">{{ op.concepto || '—' }}</div>
                    </div>
                    <div class="op-field">
                      <label class="op-label">Notario</label>
                      <div class="op-value">{{ op.notario || '—' }}</div>
                    </div>
                    <div class="op-field">
                      <label class="op-label">Protocolo</label>
                      <div class="op-value">{{ op.protocolo || '—' }}</div>
                    </div>
                    <div class="op-field">
                      <label class="op-label">IRUS</label>
                      <div class="op-value">{{ op.irus || '—' }}</div>
                    </div>
                    <div class="op-field">
                      <label class="op-label">Provincia registro mercantil</label>
                      <div class="op-value">{{ op.provinciaRM || '—' }}</div>
                    </div>
                    <div class="op-field">
                      <label class="op-label">Fecha inscripción</label>
                      <div class="op-value">{{ op.fechaInscripcion || '—' }}</div>
                    </div>
                    <div class="op-field">
                      <label class="op-label">Tomo</label>
                      <div class="op-value">{{ op.tomo || '—' }}</div>
                    </div>
                    <div class="op-field">
                      <label class="op-label">Folio</label>
                      <div class="op-value">{{ op.folio || '—' }}</div>
                    </div>
                    <div class="op-field">
                      <label class="op-label">Hoja</label>
                      <div class="op-value">{{ op.hoja || '—' }}</div>
                    </div>
                    <div class="op-field">
                      <label class="op-label">Sección</label>
                      <div class="op-value">{{ op.seccion || '—' }}</div>
                    </div>
                    <div class="op-field">
                      <label class="op-label">Libro</label>
                      <div class="op-value">{{ op.libro || '—' }}</div>
                    </div>
                    <div class="op-field">
                      <label class="op-label">Nº inscripción</label>
                      <div class="op-value">{{ op.numInscripcion || '—' }}</div>
                    </div>
                    @if (op.observaciones) {
                      <div class="op-field is-full">
                        <label class="op-label">Observaciones</label>
                        <div class="op-value op-value--obs">{{ op.observaciones }}</div>
                      </div>
                    }
                  </div>

                  <!-- Documentos adjuntos -->
                  @if (op.documentos && op.documentos.length > 0) {
                    <div class="op-documents">
                      <p class="op-documents-title">
                        <fa-icon [icon]="faFile" aria-hidden="true"></fa-icon>
                        Documentos adjuntos
                      </p>
                      <ul class="op-document-list">
                            @for (doc of op.documentos; track doc.id) {
                          <li class="op-document-item">
                            <button
                              type="button"
                              class="op-document-link"
                              (click)="downloadDocument(op.id, doc.id, doc.originalName)"
                              [title]="'Descargar ' + doc.originalName"
                            >
                              <fa-icon [icon]="faFile" aria-hidden="true"></fa-icon>
                              <span>{{ doc.originalName }}</span>
                            </button>
                          </li>
                        }
                      </ul>
                    </div>
                  }
                </div>

                @if (getOperationDetails(op).length > 0) {
                  <app-operation-detail-readonly [sections]="getOperationDetails(op)" />
                }

                @if (op.seccionesAfectadas.length === 0 && getTabAfectada(op); as tab) {
                  <div class="op-cross-tab-note" role="note">
                    <span class="op-cross-tab-pill">Pestaña {{ tab.label }}</span>
                    <span>{{ tab.accion }}</span>
                  </div>
                }

                <!-- Secciones del formulario afectadas por esta operación -->
                @if (op.seccionesAfectadas.length > 0) {
                  <div class="op-snapshot-divider">
                    <span>Campos afectados por esta operación</span>
                  </div>
                  <app-constitution-readonly [data]="snapshotForDetail(op)" [sections]="op.seccionesAfectadas" [sociosParcial]="sociosParcialLabel(op)"></app-constitution-readonly>
                } @else if (getOperationDetails(op).length === 0) {
                  <div class="op-cross-tab-note">
                    <p>Esta operación afecta a otra sección del cliente. Consulta la pestaña correspondiente para ver los cambios.</p>
                  </div>
                }

              </div>
            }
          </li>
        }
      </ol>

      } <!-- end @else -->

    </div>
  }

</div>

<!-- Modal: eliminar operación -->
<div
  class="modal delete-op-modal"
  [class.is-active]="showDeleteModal()"
  role="dialog"
  aria-modal="true"
  aria-labelledby="delete-modal-title"
>
  <div class="modal-background" (click)="closeDeleteModal()"></div>
  <div class="modal-card delete-modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title" id="delete-modal-title">Eliminar operación societaria</p>
      <button class="delete" type="button" aria-label="Cerrar" (click)="closeDeleteModal()"></button>
    </header>
    <section class="modal-card-body">
      <p class="delete-op-question">¿Estás seguro/a de que deseas eliminar esta operación societaria?</p>
      @if (deleteTarget()) {
        <p class="delete-op-name"><strong>{{ deleteTarget()!.categoriaLabel }}{{ deleteTarget()!.subtipoLabel ? ': ' + deleteTarget()!.subtipoLabel : '' }}</strong></p>
      }
      <div class="delete-op-warning" role="alert">
        <fa-icon [icon]="faTriangleExclamation" aria-hidden="true"></fa-icon>
        <span>Los cambios aplicados al cliente (capital social, socios, administración, etc.) al crear esta operación <strong>no se revertirán automáticamente</strong>.</span>
      </div>
    </section>
    <footer class="modal-card-foot delete-op-footer">
      <button
        class="button delete-op-btn-confirm"
        type="button"
        [disabled]="isDeleting()"
        (click)="confirmDelete()"
      >
        {{ isDeleting() ? 'Eliminando...' : 'Eliminar' }}
      </button>
      <button class="button delete-op-btn-cancel" type="button" (click)="closeDeleteModal()">Cancelar</button>
    </footer>
  </div>
</div>

<!-- Modal: nueva operación -->
<div class="modal new-op-modal" [class.is-active]="showNewModal()" role="dialog" aria-modal="true" aria-labelledby="modal-title">
  <div class="modal-background" (click)="closeNewModal()"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title" id="modal-title">Nueva operación societaria</p>
      <button class="delete" type="button" aria-label="Cerrar" (click)="closeNewModal()"></button>
    </header>
    <section class="modal-card-body">

      <!-- Dropdown 1: Categoría -->
      <div class="field">
        <label class="label" for="categoria-operacion">Categoría</label>
        <p-dropdown
          [options]="categoriaOptions()"
          optionLabel="label"
          optionValue="value"
          optionDisabled="disabled"
          placeholder="Selecciona una categoría..."
          [ngModel]="newCategoria()"
          (ngModelChange)="onCategoriaChange($event)"
          appendTo="body"
          [baseZIndex]="2000"
          inputId="categoria-operacion"
          class="search-input"
        ></p-dropdown>
      </div>

      <!-- Dropdown 2: Subtipo (only when category has subtypes) -->
      @if (requiresSubtipo()) {
        <div class="field">
          <label class="label" for="subtipo-operacion">Subtipo</label>
          <p-dropdown
            [options]="subtipoOptions()"
            optionLabel="label"
            optionValue="value"
            placeholder="Selecciona un subtipo..."
            [ngModel]="newSubtipo()"
            (ngModelChange)="newSubtipo.set($event)"
            appendTo="body"
            [baseZIndex]="2000"
            inputId="subtipo-operacion"
            class="search-input"
          ></p-dropdown>
        </div>
      }

    </section>
    <footer class="modal-card-foot buttons-container">
      <button class="button cancel-button" type="button" (click)="closeNewModal()">Cancelar</button>
      <button
        class="button save-button"
        type="button"
        [disabled]="!canContinue()"
        (click)="startWizard()"
      >
        Continuar
      </button>
    </footer>
  </div>
</div>

